import React from "react"
import ContractorTimeslotItem from "../create_project/contractor_timeslot_item";
import { withRouter } from "react-router-dom"
import UserAvatar from "./photograher_avatar"
import LogoSpinner from "../../../../assets/images/landing/video-thumbnails/MA-logo-spinner-transparent.gif";
import { formatDatetime } from "../../util/date_util";
import BookingCalendar from "../create_project/booking_calendar";
import debounce from 'debounce'
import { debouncePromise } from "../../util/custom_function_utils"

class ContractorCalendar extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selected: new Date(),
      selectedTime: "",
      dates: [],
      month: new Date(),
      currentDay: new Date(),
      confirmModal: false,
      isLargeScreen: typeof window === 'undefined' ? true : window.innerWidth > 750,
      loading: false
    }
    this.handler = this.handler.bind(this)
    // this.applyTime = this.applyTime.bind(this)
    this.addMonth = this.addMonth.bind(this)
    this.subtractMonth = this.subtractMonth.bind(this)
    this.addDays = this.addDays.bind(this)
    this.subtractDays = this.subtractDays.bind(this)
    this.handleTimeSelect = this.handleTimeSelect.bind(this)
    this.updatePredicate = this.updatePredicate.bind(this)
    this.debouceScrollTo = debounce((selector) => this.scrollTo(selector), 200)

    // debouncePromise only cancels a call while it's still waiting out the
    // debounce delay — once it's actually fired (a real fetchTimes request
    // in flight), a later date change can't cancel it, and if that older
    // request's response happens to arrive after the newer one, it would
    // still clear `loading` and let the (now-stale) time slots be clicked.
    // fetchRequestId makes each call's resolution conditional on still being
    // the most recent one, so a late/out-of-order response for an
    // already-superseded date is simply ignored instead of hiding the
    // loading spinner over stale times.
    this.fetchRequestId = 0
    const debouncedFetchTimes = debouncePromise((options) => {
      return this.props.fetchTimes(options);
    }, 500);
    this.debounceFetchTimes = (options) => {
      const requestId = ++this.fetchRequestId
      return new Promise((resolve) => {
        debouncedFetchTimes(options).then(() => {
          if (requestId === this.fetchRequestId) resolve()
        })
      })
    }
    this.modalContentRef = React.createRef()
  }

  componentDidMount() {
    document.body.style.overflow = 'hidden';
    this.updatePredicate();
    window.addEventListener("resize", this.updatePredicate);

    let today_date = new Date()
    today_date.setDate(today_date.getDate() + 1)

    let previous_time_set = false

    let dates = this.getDaysInMonth(today_date)
    let firstSelectable = this.getFirstSelectableDate(dates)
    this.setState({
      dates: dates,
      currentDay: firstSelectable,
      selected: firstSelectable,
      selectedTime: previous_time_set ? today_date : "",
      month: today_date,
      loading: true
    })
    this.debounceFetchTimes({
      date: firstSelectable,
      contractor_id: this.props.photographer.id,
      service_id: this.props.selectedService,
      street: null,
      timezone: this.props.detected_timezone || this.props.project?.client?.timezone || this.props.client_timezone
    }).then(() => this.setState({ loading: false }))
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updatePredicate);
    document.body.style.overflow = 'unset';
  }

  scrollTo(selector) {
    const element = document.querySelector(selector)
    if (element) element.scrollIntoView()
  }

  updatePredicate() {
    this.setState({ isLargeScreen: window.innerWidth > 550 });
  }

  addDays() {
    let currentDay = new Date(this.state.currentDay)

    if (this.state.isLargeScreen) {
      currentDay.setDate(currentDay.getDate() + 10)
    } else {
      currentDay.setDate(currentDay.getDate() + 5)
    }

    if (currentDay.getMonth() !== this.state.currentDay.getMonth()) {
      currentDay.setDate(1)
    }

    let dates = this.getDaysInMonth(currentDay)
    let firstSelectable = this.getFirstSelectableDate(dates)
    this.setState({ dates: dates, currentDay: firstSelectable, month: currentDay, selected: firstSelectable, selectedTime: "", loading: true })

    this.debounceFetchTimes({
      date: firstSelectable,
      contractor_id: this.props.photographer.id,
      service_id: this.props.selectedService,
      street: this.props.street,
      timezone: this.props.detected_timezone || this.props.project?.client?.timezone || this.props.client_timezone
    }).then(() => this.setState({ loading: false }))
  }

  subtractDays() {
    let currentDay = new Date(this.state.currentDay)

    if (this.state.isLargeScreen) {
      if (currentDay.getDate() < 11 && currentDay.getDate() != 1) {
        currentDay.setDate(1)
      } else {
        currentDay.setDate(currentDay.getDate() - 10)
      }
    } else {
      if (currentDay.getDate() < 6 && currentDay.getDate() != 1) {
        currentDay.setDate(1)
      } else {
        currentDay.setDate(currentDay.getDate() - 5)
      }
    }

    let todayDate = new Date()

    todayDate.setDate(todayDate.getDate() + 1)

    if (currentDay < todayDate && !this.props.currentUser.roles.admin) {
      let dates = this.getDaysInMonth(todayDate)
      let firstSelectable = this.getFirstSelectableDate(dates)
      this.setState({ dates: dates, currentDay: firstSelectable, month: todayDate, selected: firstSelectable, selectedTime: "", loading: true })
      this.debounceFetchTimes({
        date: firstSelectable,
        contractor_id: this.props.photographer.id,
        service_id: this.props.selectedService,
        street: this.props.street,
        timezone: this.props.detected_timezone || this.props.project?.client?.timezone || this.props.client_timezone
      }).then(() => this.setState({ loading: false }))
    } else {
      let dates = this.getDaysInMonth(currentDay)
      let firstSelectable = this.getFirstSelectableDate(dates)
      this.setState({ dates: dates, currentDay: firstSelectable, month: currentDay, selected: firstSelectable, selectedTime: "", loading: true })
      this.debounceFetchTimes({
        date: firstSelectable,
        contractor_id: this.props.photographer.id,
        service_id: this.props.selectedService,
        street: this.props.street,
        timezone: this.props.detected_timezone || this.props.project?.client?.timezone || this.props.client_timezone
      }).then(() => this.setState({ loading: false }))
    }
  }

  // applyTime() {
  //   if (this.state.selectedTime !== "") {
  //     if (this.props.updating && !this.state.confirmModal) {
  //       this.setState({ confirmModal: true })
  //       this.debouceScrollTo(".sub-modal-background")
  //     } else {
  //       this.props.setAppointmentTime(this.state.selectedTime, this.props.photographer)
  //       this.props.changeSelected(null, null, true)
  //     }
  //   }
  // }

  addMonth() {
    let date = new Date(this.state.month.getFullYear(), this.state.month.getMonth() + 1, 1)

    let dates = this.getDaysInMonth(date)

    let firstSelectable = this.getFirstSelectableDate(dates)
    this.setState({ dates: dates, month: date, currentDay: firstSelectable, selected: firstSelectable, selectedTime: "", loading: true })

    this.debounceFetchTimes({
      date: firstSelectable,
      contractor_id: this.props.photographer.id,
      service_id: this.props.selectedService,
      street: this.props.street,
      timezone: this.props.detected_timezone || this.props.project?.client?.timezone || this.props.client_timezone
    }).then(() => this.setState({ loading: false }))
  }

  subtractMonth() {
    let today_date = new Date()
    let date = new Date(this.state.month.getFullYear(), this.state.month.getMonth(), 1)

    if (date.getMonth() != today_date.getMonth() || this.props.currentUser?.roles?.admin) {
      date = new Date(this.state.month.getFullYear(), this.state.month.getMonth() - 1, 1)
    }

    let dates = this.getDaysInMonth(date)
    let firstSelectable = this.getFirstSelectableDate(dates)

    this.setState({ dates: dates, month: date, currentDay: firstSelectable, selected: firstSelectable, selectedTime: "", loading: true })

    this.debounceFetchTimes({
      date: firstSelectable,
      contractor_id: this.props.photographer.id,
      service_id: this.props.selectedService,
      street: this.props.street,
      timezone: this.props.detected_timezone || this.props.project?.client?.timezone || this.props.client_timezone
    }).then(() => this.setState({ loading: false }))
  }

  getDaysInMonth(date) {
    let month = date.getMonth()
    let year = date.getFullYear()
    let new_date = new Date(year, month, 1)
    let days = []
    while (new_date.getMonth() === month) {
      days.push(new Date(new_date))
      new_date.setDate(new_date.getDate() + 1)
    }
    return days
  }

  getFirstSelectableDate(dates) {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    return dates.find(d => {
      const normalized = new Date(d)
      normalized.setHours(0, 0, 0, 0)
      return normalized > today
    }) || dates[dates.length - 1]
  }

  changeSelected(index) {
    this.setState({ selected: this.state.dates[index], selectedTime: "", loading: true })
    this.debounceFetchTimes({
      date: this.state.dates[index],
      contractor_id: this.props.photographer.id,
      service_id: this.props.selectedService,
      street: this.props.street,
      timezone: this.props.detected_timezone || this.props.project?.client?.timezone || this.props.client_timezone
    }).then(() => this.setState({ loading: false }))
  }

  handler(newState) {
    this.setState(newState)
  }

  handleTimeSelect(time) {
    if (this.state.selectedTime.toString() === time.toString()) {
      this.setState({ selectedTime: "" })
    } else {
      this.setState({ selectedTime: time })
    }
  }


  render() {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const isAdmin = this.props.currentUser?.roles?.admin

    const isCurrentMonth = this.state.month.getMonth() === today.getMonth() &&
                           this.state.month.getFullYear() === today.getFullYear()

    const mostRecentSunday = new Date(today)
    mostRecentSunday.setDate(today.getDate() - today.getDay())
    mostRecentSunday.setHours(0, 0, 0, 0)

    const firstDate = this.state.dates[0]
    const fillerDays = []

    if (!isCurrentMonth || isAdmin || !firstDate || mostRecentSunday < firstDate) {
      const startDayOfWeek = firstDate ? firstDate.getDay() : 0
      for (let i = startDayOfWeek - 1; i >= 0; i--) {
        const fillerDate = new Date(firstDate.getFullYear(), firstDate.getMonth(), -i)
        fillerDays.push(
          <div className="createProjectDateOptions createProjectDateDisabled" key={`filler-${i}`}>
            <div className="createProjectDate">{fillerDate.getDate()}</div>
            <div className="createProjectDateDay">{fillerDate.toLocaleString('default', { weekday: 'short' })}</div>
          </div>
        )
      }
    }

    let dates = this.state.dates.map((date, index) => {
      if (isCurrentMonth && !isAdmin && firstDate && mostRecentSunday >= firstDate) {
        const normalized = new Date(date)
        normalized.setHours(0, 0, 0, 0)
        if (normalized < mostRecentSunday) return null
      }
      const normalized = new Date(date)
      normalized.setHours(0, 0, 0, 0)
      const isPast = normalized <= today
      const isSelected = this.state.selected?.toString() === date.toString()

      if (isPast) {
        return (
          <div className={`createProjectDateOptions createProjectDateDisabled${isAdmin ? " createProjectDateDisabledAdmin" : ""}`} key={index}
               id={isAdmin && isSelected ? "createProjectDateOptionSelected" : ""}
               onClick={isAdmin ? () => this.changeSelected(index) : undefined}>
            <div className="createProjectDate"
                 id={isAdmin && isSelected ? "createProjectDateSelected" : ""}>{date.getDate()}</div>
            <div className="createProjectDateDay"
                 id={isAdmin && isSelected ? "createProjectDateDaySelected" : ""}>{date.toLocaleString('default', { weekday: 'short' })}</div>
          </div>
        )
      }

      return (
        <div className="createProjectDateOptions" key={index}
             id={isSelected ? "createProjectDateOptionSelected" : ""}
             onClick={() => this.changeSelected(index)}>
          <div className="createProjectDate"
               id={isSelected ? "createProjectDateSelected" : ""}>{date.getDate()}</div>
          <div className="createProjectDateDay"
               id={isSelected ? "createProjectDateDaySelected" : ""}>{date.toLocaleString('default', { weekday: 'short' })}</div>
        </div>
      )
    })

    let selectedTime = this.state.selectedTime


    let time_slots = this.props.times.map(time => {
      return { time: new Date(time.start_time), unavailable: time.unavailable }
    })

    let times = time_slots.map((time_slot, i) =>
      <ContractorTimeslotItem key={i} time={time_slot.time} unavailable={time_slot.unavailable} selected={selectedTime.toString() === time_slot.time.toString()}
        currentUser={this.props.currentUser} detected_timezone={this.props.detected_timezone} client_timezone={this.props.client_timezone} handleTimeSelect={this.handleTimeSelect} changeParentState={this.handler} />
    )

    let photographer = this.props.photographer

    let modal = ""

    if (this.state.confirmModal) {
      modal = <div className="modal-background sub-modal-background" onClick={() => this.setState({ confirmModal: false })}>
        <div className="orderpreviewModal" onClick={e => e.stopPropagation()}>
          <div className="orderPreviewModalComponent">
            <div className="contractorModalHeading">
              <div className="confirmationModalDescription">Are you sure you want to make this change?</div>
            </div>
            <div className="confirmationTimeSlotsButtons">
              <div onClick={() => this.setState({ confirmModal: false })} className="signupFormPrevious">Cancel</div>
              <div onClick={this.applyTime} className="signupFormNext" id={this.state.selectedTime === "" ? 'disabled' : ''}>Apply</div>
            </div>
          </div>
        </div>
      </div>
    }

    const today2 = new Date()
    today2.setHours(0, 0, 0, 0)
    const isAdmin2 = this.props.currentUser?.roles?.admin
    const isCurrentMonth2 = this.state.month.getMonth() === today2.getMonth() && this.state.month.getFullYear() === today2.getFullYear()
    const lastSunday = new Date(today2)
    lastSunday.setDate(today2.getDate() - today2.getDay())
    const first = this.state.dates[0]
    const hidePastWeeks = isCurrentMonth2 && !isAdmin2 && first && lastSunday >= first
    const visible = []
    this.state.dates.forEach((date, index) => {
      const normalized = new Date(date)
      normalized.setHours(0, 0, 0, 0)
      if (hidePastWeeks && normalized < lastSunday) return
      visible.push({ date, index, normalized })
    })
    const days = []
    if (visible.length > 0) {
      for (let i = 0; i < visible[0].date.getDay(); i++) days.push({ key: `blank-${i}`, blank: true })
    }
    visible.forEach(({ date, index, normalized }) => {
      const clickable = normalized > today2 || isAdmin2
      days.push({
        key: `d-${index}`, num: date.getDate(),
        selected: clickable && this.state.selected?.toString() === date.toString(),
        disabled: !clickable,
        ariaLabel: date.toLocaleString('en-US', { weekday: 'long', month: 'long', day: 'numeric' }),
        onClick: clickable ? () => this.changeSelected(index) : undefined
      })
    })
    const timezone = this.props.detected_timezone || this.props.client_timezone || this.props.project?.client?.timezone || this.props.currentUser?.timezone
    const name = [photographer.firstName || photographer.first_name, (photographer.lastName || photographer.last_name || '')[0]].filter(Boolean).join(' ')

    return <BookingCalendar
      title={`Availability for ${photographer.firstName || photographer.first_name || 'this photographer'}`}
      subtitle="Open dates and times for this photographer."
      onClose={() => this.props.changeParentState({ contractorCalendarOpen: false })}
      headerExtra={<div className="bkCal-person">
        <UserAvatar user={photographer} />
        <div className="bkCal-personName">{name}</div>
        <a href={`/photographers/${photographer.id}`} target="_blank" rel="noopener noreferrer">Profile</a>
      </div>}
      monthLabel={this.state.month.toLocaleString('en-US', { month: 'long', year: 'numeric' })}
      onPrevMonth={this.subtractMonth}
      onNextMonth={this.addMonth}
      prevDisabled={isCurrentMonth2 && !isAdmin2}
      days={days}
      timesHeading={this.state.selected ? formatDatetime(this.state.selected, "dddd, MMMM D") : ''}
      timezoneNote={timezone ? `Times are shown in ${timezone}` : null}
      times={this.state.loading ? [] : times}
      timesLoading={this.state.loading}
      emptyTimesText="No times for this date"
      cancelLabel="Close"
    >
      {modal}
    </BookingCalendar>
  }
}

export default withRouter(ContractorCalendar)